import imageCompression from 'browser-image-compression';

type CompressImageOptions = {
  maxSizeMB?: number;
};

export async function compressImageFile(
  file: File | Blob,
  options: CompressImageOptions = {}
): Promise<File | Blob> {
    if (!file.type.startsWith('image/')) {
        return file;
    }

    const input =
    file instanceof File
      ? file
      : new File([file], "image", {
          type: file.type,
          lastModified: Date.now(),
        });

  const max = options.maxSizeMB ?? 2;

  try {
    const maxBytes = max * 1024 * 1024;
    if (maxBytes >=  file.size) {
      return file;
    }

    const compressedFile = await imageCompression(input, {
        maxSizeMB: max,
        useWebWorker: true,
    });

    if (compressedFile.size >= file.size) {
      return file;
    }

    return compressedFile
  } catch {
    return file;
  }
}